import axios from 'axios';
import { getBaseApiUrl, getRequestHeaders } from '../util/config';

const teams = {
  'Connect Lending': 'Connect Lending',
  'Community Lending': 'Community Lending',
  'Consumer Lending': 'Consumer Lending',
  'Portfolio Lending': 'Portfolio Lending',
};

export const getBusinessCardsForTeam = async (team = '') => {
  const res = await axios.get(`${getBaseApiUrl()}/Contentful/businesscards`, {
    headers: getRequestHeaders(),
  });

  if (team && !teams?.[team]) {
    console.error('Invalid team argument provided');
    throw new Error('Team not found');
  }

  if (res.status !== 200) {
    throw res.statusText;
  }

  if (!team) {
    return res.data.result;
  }
  return res.data.result?.filter(card => card.team === team);
};

export const getBusinessCard = async (uid = '') =>
  await axios.get(`${getBaseApiUrl()}/Contentful/businesscard?uid=${uid}`, {
    headers: getRequestHeaders(),
  });
